import HyperHTMLElement from 'hyperhtml-element';
import { formViewFormatters } from './formViewFormatters';
import type { BasePropertyMetadata } from './formViewFormatters';

export default class FormView extends HyperHTMLElement {
	order: Array<string> = [];
	data: Record<string, unknown> = {};
	metadata: Record<string, BasePropertyMetadata> = {};
	state: Record<string, { invalid: boolean }> = {};

	static extendFormatters(
		formatter: (
			propName: string,
			propValue: unknown,
			propMetadata: BasePropertyMetadata,
			control: FormView
		) => HTMLElement
	): void {
		Object.assign(formViewFormatters, formatter);
	}

	connectedCallback(): void {
		this.classList.add('aras-form-view');
		this.addEventListener('change', ((event: CustomEvent) =>
			this.changeData(event)) as EventListener);
	}

	render(): void {
		const propertyValues = this.data;
		const propertyFields = this.order.map((propName) => {
			const propMetadata = this.metadata[propName];
			const { type } = propMetadata;
			const formatter = formViewFormatters[type];
			if (!formatter) {
				return null;
			}

			const propValue = propertyValues[propName];
			return formatter(propName, propValue, propMetadata, this);
		});

		this.html`${propertyFields}`;
	}

	private changeData(event: CustomEvent) {
		if (event.target !== this) {
			return;
		}

		const { propName, newValue } = event.detail;
		this.data = {
			...this.data,
			[propName]: newValue
		};
		this.render();
	}
}
